import { render, staticRenderFns } from "@/modules/Task/templates/task-detail.html?vue&type=template&id=f363239c&scoped=true&"
import script from "@/modules/Task/scripts/task-detail.ts?vue&type=script&lang=js&"
export * from "@/modules/Task/scripts/task-detail.ts?vue&type=script&lang=js&"
import style0 from "@/modules/Task/styles/task-detail.scss?vue&type=style&index=0&id=f363239c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f363239c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
